/**
 * 다국어 dict에서 현재 locale에 맞는 값을 가져옵니다.
 *
 * 우선순위: exact match (e.g. "zh-CN") → base lang (e.g. "zh") → "en" → 첫 번째 값 → fallback
 */
export function resolveLocalized(
  dict: Record<string, string> | undefined | null,
  lang: string,
  fallback: string,
): string {
  if (!dict || typeof dict !== 'object') return fallback;
  const base = lang.split('-')[0];
  return dict[lang] || dict[base] || dict['en'] || Object.values(dict)[0] || fallback;
}

/**
 * 다국어 배열 dict에서 현재 locale에 맞는 배열을 가져옵니다.
 */
export function resolveLocalizedArray(
  dict: Record<string, string[]> | undefined | null,
  lang: string,
): string[] {
  if (!dict || typeof dict !== 'object') return [];
  const base = lang.split('-')[0];
  return dict[lang] || dict[base] || dict['en'] || Object.values(dict)[0] || [];
}
